{
  "DT_TO_EXPO": {
    "weekday": {
      "DT1": 1415,
      "DT2": 1417,
      "DT3": 1418,
      "DT4": 1420,
      "DT5": 1422,
      "DT6": 1424,
      "DT7": 1426,
      "DT8": 1428,
      "DT9": 1430,
      "DT10": 1433,
      "DT11": 1435,
      "DT12": 1438,
      "DT13": 1439,
      "DT14": 1441,
      "DT15": 1443,
      "DT16": 1445,
      "DT17": 1447,
      "DT18": 1448,
      "DT19": 1450,
      "DT20": 1452,
      "DT21": 1453,
      "DT22": 1455,
      "DT23": 1457,
      "DT24": 1459,
      "DT25": 1462,
      "DT26": 1464,
      "DT27": 1465,
      "DT28": 1467,
      "DT29": 1469,
      "DT30": 1471,
      "DT31": 1474,
      "DT32": 1476,
      "DT33": 1478,
      "DT34": 1481
    },
    "saturday": {
      "DT1": 1415,
      "DT2": 1417,
      "DT3": 1418,
      "DT4": 1420,
      "DT5": 1422,
      "DT6": 1424,
      "DT7": 1426,
      "DT8": 1428,
      "DT9": 1430,
      "DT10": 1433,
      "DT11": 1435,
      "DT12": 1438,
      "DT13": 1439,
      "DT14": 1441,
      "DT15": 1443,
      "DT16": 1445,
      "DT17": 1447,
      "DT18": 1448,
      "DT19": 1450,
      "DT20": 1452,
      "DT21": 1453,
      "DT22": 1455,
      "DT23": 1457,
      "DT24": 1459,
      "DT25": 1462,
      "DT26": 1464,
      "DT27": 1465,
      "DT28": 1467,
      "DT29": 1469,
      "DT30": 1471,
      "DT31": 1474,
      "DT32": 1476,
      "DT33": 1478,
      "DT34": 1481
    },
    "sunday-public-holiday": {
      "DT1": 1415,
      "DT2": 1417,
      "DT3": 1418,
      "DT4": 1420,
      "DT5": 1422,
      "DT6": 1424,
      "DT7": 1426,
      "DT8": 1428,
      "DT9": 1430,
      "DT10": 1433,
      "DT11": 1435,
      "DT12": 1438,
      "DT13": 1439,
      "DT14": 1441,
      "DT15": 1443,
      "DT16": 1445,
      "DT17": 1447,
      "DT18": 1448,
      "DT19": 1450,
      "DT20": 1452,
      "DT21": 1453,
      "DT22": 1455,
      "DT23": 1457,
      "DT24": 1459,
      "DT25": 1462,
      "DT26": 1464,
      "DT27": 1465,
      "DT28": 1467,
      "DT29": 1469,
      "DT30": 1471,
      "DT31": 1474,
      "DT32": 1476,
      "DT33": 1478,
      "DT34": 1481
    }
  },
  "DT_TO_BUKIT_PANJANG": {
    "weekday": {
      "DT35": 1420,
      "DT34": 1421,
      "DT33": 1425,
      "DT32": 1427,
      "DT31": 1429,
      "DT30": 1431,
      "DT29": 1434,
      "DT28": 1436,
      "DT27": 1438,
      "DT26": 1440,
      "DT25": 1442,
      "DT24": 1444,
      "DT23": 1446,
      "DT22": 1448,
      "DT21": 1450,
      "DT20": 1451,
      "DT19": 1454,
      "DT18": 1455,
      "DT17": 1456,
      "DT16": 1458,
      "DT15": 1460,
      "DT14": 1462,
      "DT13": 1464,
      "DT12": 1466,
      "DT11": 1468,
      "DT10": 1470,
      "DT9": 1472,
      "DT8": 1474,
      "DT7": 1476,
      "DT6": 1478,
      "DT5": 1480,
      "DT4": 1483,
      "DT3": 1485,
      "DT2": 1486
    },
    "saturday": {
      "DT35": 1420,
      "DT34": 1421,
      "DT33": 1425,
      "DT32": 1427,
      "DT31": 1429,
      "DT30": 1431,
      "DT29": 1434,
      "DT28": 1436,
      "DT27": 1438,
      "DT26": 1440,
      "DT25": 1442,
      "DT24": 1444,
      "DT23": 1446,
      "DT22": 1448,
      "DT21": 1450,
      "DT20": 1451,
      "DT19": 1454,
      "DT18": 1455,
      "DT17": 1456,
      "DT16": 1458,
      "DT15": 1460,
      "DT14": 1462,
      "DT13": 1464,
      "DT12": 1466,
      "DT11": 1468,
      "DT10": 1470,
      "DT9": 1472,
      "DT8": 1474,
      "DT7": 1476,
      "DT6": 1478,
      "DT5": 1480,
      "DT4": 1483,
      "DT3": 1485,
      "DT2": 1486
    },
    "sunday-public-holiday": {
      "DT35": 1420,
      "DT34": 1421,
      "DT33": 1425,
      "DT32": 1427,
      "DT31": 1429,
      "DT30": 1431,
      "DT29": 1434,
      "DT28": 1436,
      "DT27": 1438,
      "DT26": 1440,
      "DT25": 1442,
      "DT24": 1444,
      "DT23": 1446,
      "DT22": 1448,
      "DT21": 1450,
      "DT20": 1451,
      "DT19": 1454,
      "DT18": 1455,
      "DT17": 1456,
      "DT16": 1458,
      "DT15": 1460,
      "DT14": 1462,
      "DT13": 1464,
      "DT12": 1466,
      "DT11": 1468,
      "DT10": 1470,
      "DT9": 1472,
      "DT8": 1474,
      "DT7": 1476,
      "DT6": 1478,
      "DT5": 1480,
      "DT4": 1483,
      "DT3": 1485,
      "DT2": 1486
    }
  },
  "NE_TO_HARBOURFRONT": {
    "weekday": {
      "NE18": 1405,
      "NE17": 1408,
      "NE16": 1410,
      "NE15": 1412,
      "NE14": 1415,
      "NE13": 1417,
      "NE12": 1420,
      "NE11": 1422,
      "NE10": 1424,
      "NE9": 1426,
      "NE8": 1428,
      "NE7": 1430,
      "NE6": 1432,
      "NE5": 1435,
      "NE4": 1436,
      "NE3": 1438
    },
    "saturday": {
      "NE18": 1405,
      "NE17": 1408,
      "NE16": 1410,
      "NE15": 1412,
      "NE14": 1415,
      "NE13": 1417,
      "NE12": 1420,
      "NE11": 1422,
      "NE10": 1424,
      "NE9": 1426,
      "NE8": 1428,
      "NE7": 1430,
      "NE6": 1432,
      "NE5": 1435,
      "NE4": 1436,
      "NE3": 1438
    },
    "sunday-public-holiday": {
      "NE18": 1405,
      "NE17": 1408,
      "NE16": 1410,
      "NE15": 1412,
      "NE14": 1415,
      "NE13": 1417,
      "NE12": 1420,
      "NE11": 1422,
      "NE10": 1424,
      "NE9": 1426,
      "NE8": 1428,
      "NE7": 1430,
      "NE6": 1432,
      "NE5": 1435,
      "NE4": 1436,
      "NE3": 1438
    }
  },
  "NE_TO_PUNGGOL_COAST": {
    "weekday": {
      "NE1": 1435,
      "NE3": 1439,
      "NE4": 1441,
      "NE5": 1442,
      "NE6": 1445,
      "NE7": 1447,
      "NE8": 1449,
      "NE9": 1451,
      "NE10": 1453,
      "NE11": 1455,
      "NE12": 1457,
      "NE13": 1460,
      "NE14": 1463,
      "NE15": 1465,
      "NE16": 1467,
      "NE17": 1470
    },
    "saturday": {
      "NE1": 1435,
      "NE3": 1439,
      "NE4": 1441,
      "NE5": 1442,
      "NE6": 1445,
      "NE7": 1447,
      "NE8": 1449,
      "NE9": 1451,
      "NE10": 1453,
      "NE11": 1455,
      "NE12": 1457,
      "NE13": 1460,
      "NE14": 1463,
      "NE15": 1465,
      "NE16": 1467,
      "NE17": 1470
    },
    "sunday-public-holiday": {
      "NE1": 1435,
      "NE3": 1439,
      "NE4": 1441,
      "NE5": 1442,
      "NE6": 1445,
      "NE7": 1447,
      "NE8": 1449,
      "NE9": 1451,
      "NE10": 1453,
      "NE11": 1455,
      "NE12": 1457,
      "NE13": 1460,
      "NE14": 1463,
      "NE15": 1465,
      "NE16": 1467,
      "NE17": 1470
    }
  },
  "SK_EAST_INNER": {
    "weekday": {
      "STC": 1475
    },
    "saturday": {
      "STC": 1475
    },
    "sunday-public-holiday": {
      "STC": 1475
    }
  },
  "SK_EAST_OUTER": {
    "weekday": {
      "STC": 1475
    },
    "saturday": {
      "STC": 1475
    },
    "sunday-public-holiday": {
      "STC": 1475
    }
  },
  "SK_WEST_INNER": {
    "weekday": {
      "STC": 1477
    },
    "saturday": {
      "STC": 1477
    },
    "sunday-public-holiday": {
      "STC": 1477
    }
  },
  "SK_WEST_OUTER": {
    "weekday": {
      "STC": 1477
    },
    "saturday": {
      "STC": 1477
    },
    "sunday-public-holiday": {
      "STC": 1477
    }
  },
  "PG_EAST_INNER": {
    "weekday": {
      "PTC": 1478
    },
    "saturday": {
      "PTC": 1478
    },
    "sunday-public-holiday": {
      "PTC": 1478
    }
  },
  "PG_EAST_OUTER": {
    "weekday": {
      "PTC": 1478
    },
    "saturday": {
      "PTC": 1478
    },
    "sunday-public-holiday": {
      "PTC": 1478
    }
  },
  "PG_WEST_INNER": {
    "weekday": {
      "PTC": 1480
    },
    "saturday": {
      "PTC": 1480
    },
    "sunday-public-holiday": {
      "PTC": 1480
    }
  },
  "PG_WEST_OUTER": {
    "weekday": {
      "PTC": 1480
    },
    "saturday": {
      "PTC": 1480
    },
    "sunday-public-holiday": {
      "PTC": 1480
    }
  }
}
